.expandable-info-panel_wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.expandable-info-panel_header {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 0.5rem;
  width: 100%;
}

.expandable-info-panel_trigger {
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: none;
  border-radius: 0.25rem;
  display: flex;
  font: inherit;
  font-size: var(--font-size-default);
  gap: 0.5rem;
  height: 2.75rem;
  margin-bottom: 0;
  outline: none;
  padding: 0.5rem;
  position: relative;
  width: fit-content;
  cursor: pointer;
}

.expandable-info-panel_trigger:focus-visible {
  outline: 0.125rem dotted var(--color-navy-600);
  outline-offset: 0.125rem;
  text-decoration: underline;
}

.expandable-info-panel_trigger:hover {
  background-color: var(--color-grey-200);
  text-decoration: underline;
}

.expandable-info-panel_trigger--active {
  background-color: var(--color-navy-200);
  border-radius: 0.25rem 0.25rem 0 0;
}

.expandable-info-panel_trigger--active:after {
  background-color: var(--color-navy-200);
  content: "";
  display: block;
  height: 0.5rem;
  left: 0;
  position: absolute;
  right: 0;
  top: 100%;
  z-index: -1;
}

.expandable-info-panel_trigger--active:hover,
.expandable-info-panel_trigger--active:hover:after {
  background-color: var(--color-navy-300);
}

.expandable-info-panel_content-wrapper {
  align-items: start;
  background-color: var(--color-navy-200);
  display: grid;
  gap: 1rem;
  grid-template-columns: 1.5rem 1fr;
  padding: 1.5rem;
}

.expandable-info-panel_content-with-note-container {
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
}

.expandable-info-panel_note {
  background-color: var(--color-navy-100);
  padding: 1rem;
  /* both min and max width needed as not all react elements repect width */
  /* if react node contenct is placed next to "note" it may squish a pure "width" note */
  min-width: 15.875rem;
  max-width: 15.875rem;
}
